import axios from "axios";
import React, { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { toast } from "react-toastify";
import style from "./SignatureSetting.module.css";
import Spinner from "../../Loading/simpleLoading";

export default function SignatureSetting() {
  const [loading, setLoading] = useState(true);
  const [allSignatures, setAllSignatures] = useState([]);
  const [mySignature, setMySignature] = useState("");

  const userEmail = () => {
    const responseString = localStorage.getItem("user");
    const response = JSON.parse(responseString);
    return response.email;
  };

  const selectEmailSignature = async (e) => {
    e.preventDefault();

    const my_signature = e.target.value;
    setMySignature(e.target.value);

    try {
      setLoading(true);

      const response = await axios.post("/my-signature-setting", my_signature);

      if (response.data.status === 200) {
        toast.success(response.data.message, {
          closeOnClick: true,
          theme: "colored",
        });
      } else {
        console.log(response.data);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);

      const response = await axios.get("/getalltemps");
      if (response.status === 200) {
        setAllSignatures(
          response.data.temps.length > 0 ? response.data.temps : ""
        );

        setMySignature(
          response.data.my_signature !== null
            ? response.data.my_signature[0].id
            : ""
        );
      } else {
        console.log(response.data);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) {
    return <Spinner className="" animation="border" variant="secondary" />;
  } else {
    return (
      <>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="ms-2">Signature Settings</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {allSignatures.length > 0 ? (
            <div className={`container d-flex flex-column sigsetting`}>
              <div className="sigsettingHeader d-flex fw-bold  ">
                <div className="w-50 ps-3">Choose Signature</div>
                <div className="">To Email Address</div>
              </div>
              <div className={`${style.sigsettingContent}`}>
                <div className={`${style.dropdown}`}>
                  <select value={mySignature} onChange={selectEmailSignature}>
                    {allSignatures.map((signatures) => (
                      <option key={signatures.id} value={signatures.id}>
                        {signatures.user_template_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="email-address">{userEmail()}</div>
              </div>
            </div>
          ) : (
            <p className="text-center">Please Create Template First</p>
          )}
        </Offcanvas.Body>
      </>
    );
  }
}
